function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
import createUrl from "../../utilities/createUrl/index.js";
import createTransformationQuery from "../../utilities/createTransformationQuery/index.js";
import { useImagePreloadRenderer } from "../ImagePreloadExtractor/index.js";
import { createNonExclusiveMediaQuery } from "../../utilities/createMediaQueriesFromProps/index.js";
import intrinsicDimensionsFromProps from "../../utilities/intrinsicDimensionsFromProps/index.js";
import transformationsShape from "../transformationsShape.js";

/**
 * Render a source element. Can only be used as a child to `Picture`
 */
var Source = function Source(props) {
  var src = createUrl(props);
  var givenRenderer = props.renderPreload,
    preload = props.preload,
    lazy = props.lazy,
    _props$__createQuery = props.__createQuery,
    __createQuery = _props$__createQuery === void 0 ? createNonExclusiveMediaQuery : _props$__createQuery,
    pixelDensity = props.pixelDensity,
    viewport = props.viewport,
    elementProps = props.elementProps;
  var _intrinsicDimensionsF = intrinsicDimensionsFromProps(props),
    width = _intrinsicDimensionsF.width,
    height = _intrinsicDimensionsF.height;
  var media = __createQuery({
    viewport: viewport,
    pixelDensity: pixelDensity
  });
  var srcsetProp = lazy ? 'data-srcset' : 'srcSet';
  var fullSrcSet = "".concat(src).concat(createTransformationQuery(props));
  var sourceProps = _defineProperty({}, srcsetProp, fullSrcSet);
  var renderPreload = useImagePreloadRenderer(givenRenderer);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("source", _extends({}, sourceProps, {
    width: width,
    height: height
  }, elementProps, {
    media: media
  })), preload && renderPreload({
    rel: 'preload',
    as: 'image',
    media: media,
    href: fullSrcSet
  }));
};

/**
 * Allow Picture component to do special processing of this element
 */
// eslint-disable-next-line no-underscore-dangle
Source.__isSourceNode = true;
Source.defaultProps = {
  viewport: 'xs'
};
process.env.NODE_ENV !== "production" ? Source.propTypes = {
  /**
   * Set the desired displayed width of the image
   */
  width: PropTypes.number,
  /**
   * Set the desired displayed height of the image
   */
  height: PropTypes.number,
  /**
   * Override the pixel density provided by the parent `Picture` component
   *
   * As noted above, this is used to enhance the size of the image.
   */
  pixelDensity: PropTypes.number,
  /**
   * Viewport size to activate this image (Only supported by Source component)
   */
  viewport: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  /**
   * Props to pass to `source` or `img` element
   */
  elementProps: PropTypes.shape({}),
  /**
   * A 4 element tuple with the crop coordinates (`[x1, y1, x2, y2]`)
   * to pass to the media API. [See Media API's documentation](https://api-docs.eng.xogrp.com/details/production-media-api)
   */
  crop: PropTypes.arrayOf(PropTypes.number),
  /**
   * Enable smartCrop as the sizing strategy. [See Media API's documentation](https://api-docs.eng.xogrp.com/details/production-media-api)
   */
  smartCrop: PropTypes.bool,
  /**
   * Force image to fit in given dimensions (Only makes sense when height and width are provided).
   *
   * [See Media API's documentation](https://api-docs.eng.xogrp.com/details/production-media-api)
   */
  fit: PropTypes.bool,
  /**
   * Number of degrees to rotate the image
   *
   * [See Media API's documentation](https://api-docs.eng.xogrp.com/details/production-media-api)
   */
  rotate: PropTypes.number,
  /**
   * Set the quality parameter to all images. [See Media API's documentation](https://api-docs.eng.xogrp.com/details/production-media-api).
   */
  quality: PropTypes.string,
  /**
   * Override transformations. If array is provided, transformations are applied in the given order. Transformations shape includes
   *
   * | name | type |
   * |------|------|
   * | width | `number` |
   * | height | `number` |
   * | rotate | `number` |
   * | crop | `[x1: number, y1: number, x2: number, y2: number]` |
   * | fit | `bool` |
   * | smartCrop | `bool` |
   */
  transformations: PropTypes.oneOfType([transformationsShape, PropTypes.arrayOf(transformationsShape)])
} : void 0;
export default Source;